import { render } from "./LocatePackage.vue?vue&type=template&id=73f01083&scoped=true"
import script from "./LocatePackage.vue?vue&type=script&lang=js"
export * from "./LocatePackage.vue?vue&type=script&lang=js"

import "./LocatePackage.vue?vue&type=style&index=0&id=73f01083&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f01083"]])

export default __exports__